import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Validation from 'react-validation';
import { OverlayTrigger, Tooltip, Popover } from 'react-bootstrap';
import { Modal, Alert } from 'react-bootstrap';

import LoadingSpinner from '../components/LoadingSpinner';
import BucketsAPI from '../utils/BucketsAPI';
import PoliciesAPI from '../utils/PoliciesAPI';
import getUserIP from '../utils/getUserIP';

import './Modal.css';
import './CreatePolicyButton.css';
import brandingStyles from '../branding/brandingStyles';
import { ProxiedReactJson } from './ProxiedReactJson';
const config = require('../branding/branding.json');

class ActionsSelector extends Component {
    render() {
        return (
          <div>
            <button
              className="btn btn-xs btn-default margin-r-20
              padding-l-10 padding-r-10"
              style={brandingStyles.buttons.default}
              onClick={this.props.checkAllActions}
              disabled={this.props.disabled}
            >
              <i className="fa fa-check-square-o"/>
              &nbsp;
              Select all actions
            </button>
            <label className="checkbox-inline">
              <input
                type="checkbox"
                id="inlineCheckbox1"
                checked={this.props.checkedActions.getAction}
                name="getAction"
                onChange={this.props.handleStatementActionsChange}
                disabled={this.props.disabled}
              />
                Get
            </label>
            <label className="checkbox-inline">
              <input
                type="checkbox"
                id="inlineCheckbox3"
                checked={this.props.checkedActions.listAction}
                name="listAction"
                onChange={this.props.handleStatementActionsChange}
                disabled={this.props.disabled}
              />
                List
            </label>
            <label className="checkbox-inline">
              <input
                type="checkbox"
                id="inlineCheckbox2"
                checked={this.props.checkedActions.putAction}
                name="putAction"
                onChange={this.props.handleStatementActionsChange}
                disabled={this.props.disabled}
              />
                Put
            </label>
            <label className="checkbox-inline">
              <input
                type="checkbox"
                id="inlineCheckbox4"
                checked={this.props.checkedActions.deleteAction}
                name="deleteAction"
                onChange={this.props.handleStatementActionsChange}
                disabled={this.props.disabled}
              />
              Delete
            </label>
          </div>
        );
    }
}

ActionsSelector.propTypes = {
    handleStatementActionsChange: PropTypes.func.isRequired,
    checkAllActions: PropTypes.func.isRequired,
    checkedActions: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
};

class BucketsSelector extends Component {
    render() {
        return (
            <div>
              <strong>Applies to :&nbsp;</strong>
              <label className="checkbox-inline">
                <input
                  type="checkbox"
                  id="levelCheckbox1"
                  name="bucketLevel"
                  checked={this.props.bucketLevel}
                  onChange={this.props.handleLevelChange}
                  disabled={this.props.disabled}
                />
                Bucket level
              </label>
              <label className="checkbox-inline">
                <input
                  type="checkbox"
                  id="levelCheckbox3"
                  name="objectsLevel"
                  checked={this.props.objectsLevel}
                  onChange={this.props.handleLevelChange}
                  disabled={this.props.disabled}
                />
                Objects-in-bucket level
              </label>
              <br />
              <br />
              <strong>For :</strong>
              <div className="radio">
                  <label>
                    <input
                      type="radio"
                      name="bucketsSelectionType"
                      id="bucketsSelectionType1"
                      value={true}
                      onChange={this.props.handleSelectionType}
                      checked={this.props.selectionType}
                      disabled={this.props.disabled}
                    />
                    All buckets
                  </label>
              </div>
              <div className="radio">
                <label>
                  <input
                    type="radio"
                    name="bucketsSelectionType"
                    id="bucketsSelectionType2"
                    value={false}
                    onChange={this.props.handleSelectionType}
                    checked={!this.props.selectionType}
                    disabled={this.props.disabled}
                  />
                  Only :
                </label>
              </div>
              <select
                className="form-control disabled"
                onChange={this.props.handleSelection}
                style={brandingStyles.backgrounds.input}
                disabled={this.props.disabled}
              >
                {
                    this.props.buckets.map(item => (
                    <option value={item.Name} key={item.Name}>
                      {item.Name}
                    </option>
                    ))
                }
              </select>
            </div>
        );
    }
}

BucketsSelector.propTypes = {
    buckets: PropTypes.array.isRequired,
    selectionType: PropTypes.bool.isRequired,
    handleSelection: PropTypes.func.isRequired,
    handleSelectionType: PropTypes.func.isRequired,
    bucketLevel: PropTypes.bool.isRequired,
    objectsLevel: PropTypes.bool.isRequired,
    handleLevelChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

class SourceSelector extends Component {
    setUserIp() {
        getUserIP(ip => {
            this.props.handleSelection(
                {
                    target: {
                        value: ip,
                    },
                }
            );
        });
    }

    render() {
        return (
          <div>
            <div className="radio">
                <label>
                  <input
                    type="radio"
                    name="sourceSelectionType"
                    id="sourceSelectionType1"
                    value={true}
                    checked={this.props.selectionType}
                    onChange={this.props.handleSelectionType}
                    disabled={this.props.disabled}
                  />
                  Any source
                </label>
            </div>
            <div className="radio">
              <label>
                <input
                  type="radio"
                  name="sourceSelectionType"
                  id="sourceSelectionType2"
                  value={false}
                  checked={!this.props.selectionType}
                  onChange={this.props.handleSelectionType}
                  disabled={this.props.disabled}
                />
                Only :
              </label>
              <button
                className="btn btn-xs btn-default pull-right"
                onClick={this.setUserIp.bind(this)}
                style={brandingStyles.buttons.default}
                disabled={this.props.disabled}
              >
                <i className="fa fa-arrow-down" />
                &nbsp;
                {'Set to my IP'}
              </button>
            </div>
            <Validation.components.Form>
                <Validation.components.Input
                  className="form-control"
                  type="text"
                  placeholder="CIDR notation e.g:   x.x.x.x/24"
                  value={this.props.selected}
                  onChange={this.props.handleSelection}
                  validations={['validCIDR']}
                  style={brandingStyles.backgrounds.input}
                  disabled={this.props.disabled}
                />
            </Validation.components.Form>
          </div>
        );
    }
}

SourceSelector.propTypes = {
    selected: PropTypes.string.isRequired,
    selectionType: PropTypes.bool.isRequired,
    handleSelection: PropTypes.func.isRequired,
    handleSelectionType: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};


class CreatePolicyButton extends Component {

    constructor() {
        super();
        this.state = {
            buckets: [],
            policyName: '',
            showModal: false,
            advancedMode: false,
            listAllMyBucketsCheckbox: false,
            statementForm: {
                name: '',
                actions: {
                    putAction: false,
                    listAction: true,
                    deleteAction: false,
                    getAction: true,
                },
                buckets: {
                    all: true,
                    selected: null,
                },
                source: {
                    all: true,
                    selected: '',
                },
                bucketLevel: true,
                objectsLevel: true,
            },
            policy: {
                Version: '2012-10-17',
                Statement: [
                ],
            },
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.resetPolicy = this.resetPolicy.bind(this);
        this.refresh = this.refresh.bind(this);
        this.getStatementBase = this.getStatementBase.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handlePolicyNameChange = this.handlePolicyNameChange.bind(this);
        this.handleAddStatement = this.handleAddStatement.bind(this);
        this.handleAddEmptyStatement = this.handleAddEmptyStatement.bind(this);
        this.handleStatementChange
        = this.handleStatementChange.bind(this);
        this.handleBucketSelection = this.handleBucketSelection.bind(this);
        this.handleBucketSelectionType
        = this.handleBucketSelectionType.bind(this);
        this.handleSourceSelection = this.handleSourceSelection.bind(this);
        this.handleSourceSelectionType
        = this.handleSourceSelectionType.bind(this);
        this.handleStatementActionsChange
        = this.handleStatementActionsChange.bind(this);
        this.toggleAdvanced = this.toggleAdvanced.bind(this);
        this.checkAllActions = this.checkAllActions.bind(this);
        this.submit = this.submit.bind(this);
        this.handleListAllMyBucketsChange = this.handleListAllMyBucketsChange.bind(this);
    }

    resetForm() {
        this.setState(
            {
                listAllMyBucketsCheckbox: false,
                statementForm: {
                    name: '',
                    actions: {
                        putAction: false,
                        listAction: true,
                        deleteAction: false,
                        getAction: true,
                    },
                    buckets: {
                        all: true,
                        selected: (this.state.buckets[0]
                          && this.state.buckets[0].Name)
                          || '',
                    },
                    source: {
                        all: true,
                        selected: '',
                    },
                    bucketLevel: true,
                    objectsLevel: true,
                },
            }
        );
    }

    resetPolicy() {
        this.setState(
            {
                policyName: '',
                submitError: null,
                policy: {
                    Version: '2012-10-17',
                    Statement: [
                    ],
                },
            }
        );
    }

    // Open react-bootstrap modal
    openModal() {
        this.setState({ showModal: true });
        this.refresh();
    }

    // Close react-bootstrap modal
    closeModal() {
        this.resetForm();
        this.resetPolicy();
        this.setState({ showModal: false, dataLoaded: false });
    }

    refresh() {
        BucketsAPI.getBuckets().then(res => {
            this.setState({
                buckets: res.buckets,
                dataLoaded: true,
                statementForm: Object.assign(
                    {},
                    this.state.statementForm,
                    {
                        buckets: {
                            all: true,
                            selected: (res.buckets[0] && res.buckets[0].Name)
                            || '',
                        },
                    }
                ),
            }
            );
        });
    }

    submit() {
        PoliciesAPI.createPolicy(
          this.state.policyName,
          JSON.stringify(this.state.policy)
        ).then(() => {
            this.closeModal();
            if (this.props.callback) {
                this.props.callback();
            }
        })
        .catch(err => {
            this.setState({ submitError: err.response.body.error });
        });
    }

    getFormattedActions(actions) {
        const res = [];
        if (actions.getAction) {
            res.push('s3:Get*');
        }
        if (actions.putAction) {
            res.push('s3:Put*');
            res.push('s3:CreateBucket');
            res.push('s3:AbortMultipartUpload');
        }
        if (actions.listAction) {
            res.push('s3:List*');
        }
        if (actions.deleteAction) {
            res.push('s3:Delete*');
        }
        return res;
    }

    getFormattedResource(buckets, bucketLevel, objectsLevel) {
        const res = [];
        if (buckets.all) {
            if (bucketLevel) {
                res.push('arn:aws:s3:::*');
            }
            if (objectsLevel) {
                res.push('arn:aws:s3:::*/*');
            }
        } else if (!buckets.all && buckets.selected) {
            if (bucketLevel) {
                res.push(`arn:aws:s3:::${buckets.selected}`);
            }
            if (objectsLevel) {
                res.push(`arn:aws:s3:::${buckets.selected}/*`);
            }
        }
        return res;
    }

    getStatementBase() {
        const form = this.state.statementForm;
        const base = {
            Sid: form.name,
            Action: this.getFormattedActions(form.actions),
            Effect: 'Allow',
            Resource: this.getFormattedResource(form.buckets,
              form.bucketLevel, form.objectsLevel),
        };
        if (!form.source.all) {
            base.Condition = {
                IpAddress: { 'aws:SourceIp': form.source.selected },
            };
        }
        return base;
    }

    getListAllMyBucketsStatement() {
        return {
            Sid: 'ListAllMyBucketsDefault',
            Action: 's3:ListAllMyBuckets',
            Effect: 'Allow',
            Resource: 'arn:aws:s3:::*',
        };
    }

    handleAddStatement() {
        let base;
        if (!this.state.listAllMyBucketsCheckbox) {
            base = this.getStatementBase();
        } else {
            base = this.getListAllMyBucketsStatement();
        }
        const current = this.state.policy;
        current.Statement.push(base);
        this.setState({ policy: current });
        this.resetForm();
    }

    handleAddEmptyStatement() {
        const current = this.state.policy;
        current.Statement.push({
            Sid: '',
            Action: '',
            Effect: 'Allow',
            Resource: '',
        });
        this.setState({ policy: current });
    }

    handleEdit(value) {
        this.setState({ policy: value.updated_src });
    }

    handleListAllMyBucketsChange(event) {
        this.setState({ listAllMyBucketsCheckbox: event.target.checked });
    }

    handleStatementActionsChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox'
        ? target.checked : target.value;
        const name = target.name;

        const statementActions = Object.assign(
          {},
          this.state.statementForm.actions,
          { [name]: value }
        );
        const statement = this.state.statementForm;
        statement.actions = statementActions;

        this.setState({
            statementForm: statement,
        });
    }

    handlePolicyNameChange(event) {
        this.setState({
            policyName: event.target.value,
        });
    }

    handleStatementChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox'
        ? target.checked : target.value;
        const name = target.name;

        const statement = Object.assign(
          {},
          this.state.statementForm,
          { [name]: value }
        );
        this.setState({
            statementForm: statement,
        });
    }


    handleBucketSelection(event) {
        const current = this.state.statementForm;
        current.buckets = {
            all: false,
            selected: event.target.value,
        };
        this.setState({
            statementForm: current,
        });
    }

    handleBucketSelectionType(event) {
        const current = this.state.statementForm;
        current.buckets = Object.assign(
          {},
          current.buckets,
          { all: event.target.value === 'true' }
        );
        this.setState({
            statementForm: current,
        });
    }

    handleSourceSelection(event) {
        const current = this.state.statementForm;
        current.source = {
            all: false,
            selected: event.target.value,
        };
        this.setState({
            statementForm: current,
        });
    }

    handleSourceSelectionType(event) {
        const current = this.state.statementForm;
        current.source = Object.assign(
          {},
          current.source,
          { all: event.target.value === 'true' },
          event.target.value === 'true' ? { selected: '' } : {}
        );
        this.setState({
            statementForm: current,
        });
    }


    checkAllActions() {
        const statement = this.state.statementForm;
        statement.actions = {
            putAction: true,
            listAction: true,
            deleteAction: true,
            getAction: true,
        };

        this.setState({
            statementForm: statement,
        });
    }


    toggleAdvanced() {
        this.setState({ advancedMode: !this.state.advancedMode });
    }

    render() {
        const advancedModeComponent = (
          <div>
            <button
              className="btn btn-primary margin-b-10"
              style={brandingStyles.buttons.primary}
              onClick={this.handleAddEmptyStatement}
            >
              <i className="fa fa-plus-circle"/>
              &nbsp;
              Add an empty statement
            </button>
            <ProxiedReactJson
              src={this.state.policy}
              theme={config.darkUICharts ? 'summerfruit' : 'rjv-default'}
              style={{
                  height: '601px',
                  overflowY: 'scroll',
              }}
              displayDataTypes={false}
              displayObjectSize={false}
              enableClipboard={false}
              onAdd={this.handleEdit}
              onEdit={this.handleEdit}
              onDelete={this.handleEdit}
            />
          </div>
        );

        const addStatementDisabled = (() => {
            if (!this.state.listAllMyBucketsCheckbox) {
                return (
                    (
                        !this.state.statementForm.bucketLevel
                  && !this.state.statementForm.objectsLevel
                    ) || (
                        !this.state.statementForm.actions.getAction
                  && !this.state.statementForm.actions.putAction
                  && !this.state.statementForm.actions.listAction
                  && !this.state.statementForm.actions.deleteAction
                    ) || (
                        !this.state.statementForm.name ||
                  !this.state.statementForm.name.match(/^[a-zA-Z0-9]+$/)
                    ) || (
                        !this.state.statementForm.source.all &&
                  !this.state.statementForm.source.selected
                    )
                );
            }
            return false;
        })();


        const policyCreatorComponent = (
          <div className="row">
            <div className="col-md-6">
              <h4>
                Add a statement
              </h4>
              <div className="form-group">
                <label>Predefined Statement:</label>
                <label className="checkbox-inline margin-l-20">
                  <input
                    type="checkbox"
                    id="inlineCheckbox1"
                    checked={this.state.listAllMyBucketsCheckbox}
                    name="predefinedStatement1"
                    onChange={this.handleListAllMyBucketsChange}
                  />
                    ListAllMyBuckets
                    <OverlayTrigger
                      trigger={['hover', 'focus']}
                      placement="bottom"
                      overlay={
                        <Popover
                          id="popover-listallmybucket"
                          title="ListAllMyBuckets"
                        >
                          <p>ListAllMyBuckets is required for seeing the list of buckets via the console</p>
                          <p>This action is strongly advised to use the console
                             for S3 administration, especially via UI.</p>
                          <p>This action needs to be specified on all the resources (&quot;arn:aws:s3:::*&quot;)</p>
                        </Popover>
                      }>
                      <i className="fa fa-question-circle-o margin-l-10" ></i>
                    </OverlayTrigger>
                </label>
              </div>
              <div style={{ opacity: this.state.listAllMyBucketsCheckbox ? 0.3 : 1 }}>
                <div className="form-group">
                  <label>Statement Name:</label>
                  <Validation.components.Form>
                      <Validation.components.Input
                        id="statementNameInput"
                        placeholder="Name"
                        name="name"
                        className="form-control"
                        type="text"
                        value={this.state.statementForm.name}
                        onChange={this.handleStatementChange}
                        validations={['validPolicyStatementElement']}
                        style={brandingStyles.backgrounds.input}
                        disabled={this.state.listAllMyBucketsCheckbox}
                      />
                  </Validation.components.Form>
                </div>
                <div className="margin-t-30">
                  <h5 className="policyFormTitle">
                    <i
                      style={brandingStyles.mainColor}
                      className="fa fa-flask"
                    />
                    &nbsp;
                    <span >1.</span> Actions
                  </h5>
                  <ActionsSelector
                    checkedActions={this.state.statementForm.actions}
                    checkAllActions={this.checkAllActions}
                    handleStatementActionsChange
                        ={this.handleStatementActionsChange}
                    disabled={this.state.listAllMyBucketsCheckbox}
                  />
                </div>
                <div className="margin-t-30">
                  <h5 className="policyFormTitle">
                    <i
                      style={brandingStyles.mainColor}
                      className="fa fa-shopping-basket"
                    />
                    &nbsp;
                    <span >2.</span> Buckets
                  </h5>
                  <BucketsSelector
                    buckets={this.state.buckets}
                    selectionType={this.state.statementForm.buckets.all}
                    handleSelection={this.handleBucketSelection}
                    handleSelectionType={this.handleBucketSelectionType}
                    bucketLevel={this.state.statementForm.bucketLevel}
                    objectsLevel={this.state.statementForm.objectsLevel}
                    handleLevelChange={this.handleStatementChange}
                    disabled={this.state.listAllMyBucketsCheckbox}
                  />
                </div>
                <div className="margin-t-30">
                  <h5 className="policyFormTitle">
                    <i
                      style={brandingStyles.mainColor}
                      className="fa fa-sitemap"
                    />
                    &nbsp;
                    <span >3.</span> Source
                  </h5>
                  <SourceSelector
                    selected={this.state.statementForm.source.selected}
                    selectionType={this.state.statementForm.source.all}
                    handleSelection={this.handleSourceSelection}
                    handleSelectionType={this.handleSourceSelectionType}
                    disabled={this.state.listAllMyBucketsCheckbox}
                  />
                </div>
              </div>
              <hr />
              <button
                className="btn btn-primary pull-right"
                style={brandingStyles.buttons.primary}
                onClick={this.handleAddStatement}
                disabled={addStatementDisabled
                }
              >
                <i className="fa fa-plus-circle"/>
                &nbsp;
                Add statement
              </button>
            </div>
            <div className="col-md-6">
              <h4>
                Policy preview
              </h4>
              <ProxiedReactJson
                src={this.state.policy}
                theme={config.darkUICharts ? 'summerfruit' : 'rjv-default'}
                style={{
                    height: '604px',
                    overflowY: 'scroll',
                }}
                displayDataTypes={false}
                displayObjectSize={false}
                enableClipboard={false}
              />
            </div>
          </div>
        );

        return (
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="top"
            overlay={
              <Tooltip id="userGroupsTooltip">
                {'Create a new policy'}
              </Tooltip>
          }>
            <button
              className="btn btn-primary"
              style={brandingStyles.buttons.primary}
              onClick={this.openModal}
            >
                <i className="fa fa-key"></i>
                &nbsp;
                New policy
                <Modal
                  show={this.state.showModal}
                  onHide={this.closeModal}
                  bsSize="large"
                >
                    <Modal.Header
                      style={brandingStyles.backgrounds.panelHeader}
                    >
                        <Modal.Title
                          style={brandingStyles.backgrounds.panelHeader}
                        >
                            <i
                              className="fa fa-key"
                              style={brandingStyles.mainColor}
                            ></i>
                            &nbsp;
                            {'Create new policy '}
                            <i
                                className="fa fa-times pull-right clickable"
                                style={Object.assign(
                                  { marginTop: '3px' },
                                  brandingStyles.mainColor
                                )}
                                onClick={this.closeModal}
                            ></i>
                            <button
                              className="btn btn-sm btn-primary
                              pull-right margin-r-20"
                              style={brandingStyles.buttons.primary}
                              onClick={this.toggleAdvanced}
                            >
                              <i className="fa fa-code"/>
                              &nbsp;
                              Toggle Advanced Mode
                            </button>
                            <button
                              className="btn btn-sm btn-primary
                              pull-right margin-r-10"
                              style={brandingStyles.buttons.primary}
                              onClick={this.resetPolicy}
                            >
                              Reset
                            </button>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={brandingStyles.backgrounds.panel}>
                      {
                          this.state.dataLoaded &&
                        (
                          <div className="form-group">
                            <label>Policy Name:</label>
                            <Validation.components.Form>
                                <Validation.components.Input
                                  name="policyName"
                                  className="form-control"
                                  type="text"
                                  value={this.state.policyName}
                                  onChange={this.handlePolicyNameChange}
                                  validations={['validPolicyElement']}
                                  style={brandingStyles.backgrounds.input}
                                />
                            </Validation.components.Form>

                          </div>
                        )
                      }
                      {
                          this.state.dataLoaded &&
                        (this.state.advancedMode
                        && advancedModeComponent
                        || policyCreatorComponent) ||
                        <LoadingSpinner />
                      }
                    </Modal.Body>
                    <Modal.Footer style={brandingStyles.backgrounds.panel}>
                      {
                          this.state.submitError && (
                          <Alert
                            bsStyle="danger"
                            className="pull-left"
                            style={{
                                width: '75%',
                                textAlign: 'left',
                            }}
                          >
                            <strong>Error : </strong>
                            {this.state.submitError}
                          </Alert>
                          )
                      }
                      {
                          this.state.dataLoaded && (
                          <button
                            className="btn btn-primary"
                            style={brandingStyles.buttons.primary}
                            disabled={
                              !this.state.policyName
                              ||
                              !this.state.policyName
                              .match(/^[a-zA-Z0-9=,.@\-_+]+$/)
                            }
                            onClick={this.submit}
                          >
                            <i className="fa fa-check"/>
                            &nbsp;
                            Submit
                          </button>
                          )
                      }
                    </Modal.Footer>
                </Modal>
            </button>
          </OverlayTrigger>
        );
    }

}

CreatePolicyButton.propTypes = {
    callback: PropTypes.func,
};

export default CreatePolicyButton;



/** WEBPACK FOOTER **
 ** ./src/components/CreatePolicyButton.js
 **/